import {fetchDesignerSettings, fetchLayouts} from '@components/Designer/designerSlice';
import fetchCommonRefs from './fetchCommonRefs';

export default function fetchDesignerBase({
    store, headers, baseUrl, params, options
}) {
    return [
        store.dispatch(fetchDesignerSettings({
            headers, baseUrl, params, options
        })),
        store.dispatch(fetchLayouts({
            params, options: {...options, headers}
        })),
        ...fetchCommonRefs({
            store, headers, baseUrl, options
        })
    ];
}
